/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-face-satisfied-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zM7.187 6.875a1.563 1.563 0 11-1.562 1.563 1.55 1.55 0 011.563-1.563zM10 15a5 5 0 01-4.281-2.431l1.068-.625a3.75 3.75 0 006.426 0l1.068.625A5 5 0 0110 15zm2.813-5a1.563 1.563 0 111.562-1.563A1.55 1.55 0 0112.812 10z"/>'
  }
})
